export default __webpack_public_path__ + "static/media/xx99-mark-ii.0ae37891.png";